<template>
  <div>
    <!-- Edit Pop-Up -->
    <div class="position-relative d-flex" v-if="!loading">
      <div class="col-md-6">
        <!-- Title -->
        <div class="col-md-12 text-left" style="margin-top: -30px">
          <label for="title" class="col-sm-2 col-form-label"
            >Title<em class="asterisk">*</em></label
          >
          <!-- <input
            type="text"
            class="form-control"
            id="title"
            maxLength="30"
            v-cloak
            /> -->
          <v-text-field
            :loading="processLoading"
            type="text"
            id="title"
            class="pt-0"
            placeholder="Title"
            v-model="getDrips[selectedDrip(id)]['title']"
            :rules="[rules.titleCounter, rules.required]"
            counter
            solo
          ></v-text-field>
          <Emoji
            :topStyleBlock="98"
            :rightStyleBlock="12"
            :topStyleIcon="60"
            :rightStyleIcon="14"
            @addEmoji="
              (emoji) =>
                (this.getDrips[this.selectedDrip(this.id)].title += emoji)
            "
          />
        </div>
        <!-- Message -->
        <div class="col-md-12 text-left" style="margin-top: -14px">
          <label for="msg" class="col-sm-2 col-form-label">Message</label>
          <!-- <input
            type="text"
            class="form-control"
            id="msg"
            maxLength="50"
            v-cloak
            placeholder="Type your message ... "
            /> -->
          <v-text-field
            :loading="processLoading"
            type="text"
            id="message"
            class="pt-0"
            placeholder="Message"
            v-model="getDrips[selectedDrip(id)]['body']"
            :rules="[rules.bodyCounter]"
            counter
            solo
          ></v-text-field>
          <Emoji
            :topStyleBlock="98"
            :rightStyleBlock="12"
            :topStyleIcon="60"
            :rightStyleIcon="14"
            @addEmoji="
              (emoji) =>
                (this.getDrips[this.selectedDrip(this.id)]['body'] += emoji)
            "
          />
        </div>
        <!-- Url -->
        <div class="col-md-12 text-left" style="margin-top: -14px">
          <label for="url" class="col-sm-2 col-form-label">Url</label>
          <!-- <input
            type="text"
            class="form-control"
            id="url"
            v-cloak
            placeholder="URL"
            /> -->
          <v-text-field
            :loading="processLoading"
            type="text"
            id="url"
            class="pt-0"
            placeholder="URL"
            v-model="getDrips[selectedDrip(id)]['url']"
            counter
            solo
          ></v-text-field>
        </div>
        <!-- Schedule -->
        <div
          class="form-group d-flex flex-row-reverse justify-content-end w-100"
        >
          <div class="col-sm-10 text-left" style="direction: rtl">
            <label for="schedule">Schedule</label>
            <input
              type="checkbox"
              class="mr-2"
              id="schedule"
              :checked="showSchedule"
              @click="showSchedule = !showSchedule"
            />
          </div>
        </div>
        <!-- <transition
            class="animate__faster"
            enter-active-class="animate__animated animate__slideInLeft animate__faster"
            leave-active-class="animate__animated animate__slideOutLeft animate__faster"
          > -->
        <div
          class="d-flex flex-row align-items col-12 text-right"
          style="margin-top: -35px"
          v-if="showSchedule"
        >
          <!-- Days -->
          <div class="mr-3 text-left">
            <label for="src">Days</label>
            <input
              type="text"
              id="after_days"
              style="width: 56px"
              class="form-control"
              v-model="
                checkField(getDrips[selectedDrip(id)]['schedules'])[
                  'after_days'
                ]
              "
              v-cloak
            />
          </div>
          <!-- Hours -->
          <div class="mr-3 text-left">
            <label for="medium">Hours</label>
            <input
              type="text"
              id="after_hours"
              style="width: 56px"
              class="form-control"
              v-model="
                checkField(getDrips[selectedDrip(id)]['schedules'])[
                  'after_hours'
                ]
              "
              v-cloak
            />
          </div>
          <!-- Minutes -->
          <div class="mr-3 text-left">
            <label for="name">Minutes</label>
            <input
              type="text"
              id="after_mins"
              style="width: 56px"
              class="form-control"
              v-model="
                checkField(getDrips[selectedDrip(id)]['schedules'])[
                  'after_mins'
                ]
              "
              v-cloak
            />
          </div>
          <div class="d-flex flex-column text-center">
            <div>
              <label for="expiry">Send Notification Expiry</label>
            </div>
            <div class="select-group d-flex flex-column">
              <input
                type="text"
                class="border"
                style="width: 183px !important; height: 39px"
                v-model="getDrips[selectedDrip(id)].customization.ttl"
              />
              <!-- <select
                  name="expiry"
                  v-model="expiryType"
                  style="width: 65px"
                  class="ml-3"
                >
                  <option value="mins">mins</option>
                  <option value="hours">hours</option>
                  <option value="days">days</option>
                </select> -->
              <small>Default - 2 hours (7200 seconds)</small>
            </div>
          </div>
        </div>
        <!-- </transition> -->
        <!-- Set Notification Expiry -->
        <!-- Custom Icon -->
        <div
          class="col-md-12 text-left mb-4 pl-3 d-flex flex-column"
          style="margin-top: -31px"
        >
          <label for="icon">Custom Icon</label>
          <v-file-input
            :loading="processLoading"
            :clearable="false"
            counter
            show-size
            truncate-length="15"
            id="icon"
            accept="image/png, image/jpeg"
            @change="iconImgForPush"
          ></v-file-input>
        </div>
        <v-divider></v-divider>
        <div class="form-group mb-4">
          <!-- Additional Customization -->
          <h4 class="mt-3">Additional Customization</h4>
          <!-- Add Large Image -->
          <div class="form-group d-flex flex-row w-100">
            <input
              type="checkbox"
              id="lgImgCheckbox"
              :checked="shwLargeImg"
              @click="shwLargeImg = !shwLargeImg"
            />
            <div class="d-flex flex-column w-100">
              <label for="large-img">Add Large Image</label>
              <div class="overflow-hidden">
                <transition
                  class="animate__faster"
                  enter-active-class="animate__animated animate__slideInDown animate__faster"
                  leave-active-class="animate__animated animate__slideOutUp animate__faster"
                >
                  <div v-if="shwLargeImg">
                    <v-file-input
                      :loading="processLoading"
                      :clearable="false"
                      counter
                      show-size
                      truncate-length="15"
                      id="lgImage"
                      accept="image/png, image/jpeg"
                      @change="lgImgForPush"
                    ></v-file-input>
                    <!-- <input type="file" @change="lgImgForPush" />
                      <br />
                      <small>(Recommended Size: 720x360 pixels)</small> -->
                  </div>
                </transition>
              </div>
            </div>
          </div>
          <!-- Action Buttons -->
          <div class="form-group d-flex flex-column mb-0">
            <div class="d-flex flex-row-reverse justify-content-end">
              <transition
                class="animate__faster"
                enter-active-class="animate__animated animate__fadeIn animate__faster"
                leave-active-class="animate__animated animate__fadeOut animate__faster"
              >
                <select
                  name="btns"
                  class="ml-2 px-2 blue"
                  style="color: #fff"
                  v-if="shwActionBtns"
                  v-on:change="shwBtn2 = !shwBtn2"
                >
                  <option value="1">1 Button</option>
                  <option value="2">2 Buttons</option>
                </select>
              </transition>
              <label
                for="actionBtns"
                class="flex-row-reverse justify-content-end"
                >Action Buttons</label
              >
              <input
                type="checkbox"
                :checked="shwActionBtns"
                id="actionBtns"
                @click="
                  shwActionBtns = !shwActionBtns;
                  shwBtn1 = !shwBtn1;
                  shwBtn2 = false;
                "
              />
            </div>
            <transition-group
              tag="div"
              class="d-flex flex-column mt-3 mb-6"
              enter-active-class="animate__animated animate__slideInLeft animate__faster"
              leave-active-class="animate__animated animate__slideOutLeft animate__faster"
            >
              <div
                v-if="shwActionBtns"
                :key="0"
                class="d-flex flex-column justify-content-center align-items-center"
              >
                <span class="font-weight-bolder text-decoration-underline">
                  Button 1
                </span>
                <div
                  class="d-flex flex-row position-relative align-items-baseline"
                >
                  <label for="title" class="text-center mr-2 pl-2"
                    >Title:</label
                  >
                  <!-- <input
                    v-model="button1.button1.title"
                    type="text"
                    placeholder="Button 1"
                    class="w-100 text-left border"
                  /> -->
                  <v-text-field
                    :loading="processLoading"
                    type="text"
                    class="pt-0"
                    placeholder="Button 1"
                    v-model="button1.button1.title"
                    counter
                    dense
                    solo
                  ></v-text-field>
                  <Emoji
                    :heightBlock="280"
                    :topStyleBlock="30"
                    :rightStyleBlock="0"
                    :topStyleIcon="5"
                    :rightStyleIcon="5"
                    @addEmoji="(emoji) => (this.button1.button1.title += emoji)"
                  />
                </div>
                <!-- <div class="d-flex flex-row">
                    <label
                      for="url"
                      class="text-center pl-2"
                      style="margin-right: 5px"
                      >URL:</label
                    >
                    <input
                      v-model="getDrips[0].customization.button1.url"
                      type="text"
                      placeholder="URL"
                      class="w-100 text-left border"
                    />
                  </div> -->
              </div>
              <div
                :key="1"
                v-if="shwBtn2"
                class="d-flex flex-column justify-content-center align-items-center"
              >
                <span class="font-weight-bolder text-decoration-underline">
                  Button 2
                </span>
                <div
                  class="d-flex flex-row position-relative align-items-baseline"
                >
                  <label for="title" class="text-center mr-2 pl-2"
                    >Title:</label
                  >
                  <!-- <input
                    v-model="button2.button2.title"
                    type="text"
                    placeholder="Button 2"
                    class="w-100 text-left border"
                  /> -->
                  <v-text-field
                    :loading="processLoading"
                    type="text"
                    class="pt-0"
                    placeholder="Button 2"
                    v-model="button2.button2.title"
                    counter
                    dense
                    solo
                  ></v-text-field>
                  <Emoji
                    :heightBlock="280"
                    :topStyleBlock="30"
                    :rightStyleBlock="0"
                    :topStyleIcon="5"
                    :rightStyleIcon="5"
                    @addEmoji="(emoji) => (this.button2.button2.title += emoji)"
                  />
                </div>
                <!-- <div class="d-flex flex-row">
                    <label
                      for="url"
                      class="text-center pl-2"
                      style="margin-right: 5px"
                      >URL:</label
                    >
                    <input
                      v-model="getDrips[0].customization.button2.url"
                      type="text"
                      placeholder="URL"
                      class="w-100 text-left border"
                    />
                  </div> -->
              </div>
            </transition-group>
          </div>
          <!-- <div class="form-group d-flex flex-row"> -->
          <!-- <div class="d-flex flex-row-reverse justify-content-end">
                <label for="expiry" class="font-weight-bolder"
                  >Send Notification Expiry</label
                >
                <input
                  type="checkbox"
                  class="form-control"
                  :checked="!!getDrips.customization.ttl"
                  id="expiry"
                />
              </div> -->
          <!-- <div class="select-group">
                <input
                  type="text"
                  class="border ml-2"
                  v-model="getDrips.customization.ttl"
                /> -->
          <!-- <select
                  class="form-select border text-center ml-2"
                  style="width: 50px"
                >
                  <option selected>10</option>
                  <option value="11">11</option>
                </select>
                <select
                  class="form-select border text-center ml-2"
                  style="width: 50px"
                >
                  <option selected value="mins">mins</option>
                  <option value="hours">hours</option>
                  <option value="days">days</option>
                </select> -->
          <!-- </div>
            </div> -->
        </div>
        <!-- <div class="col-md-12 text-left mb-4 p-0">
            <input type="file" id="cust_icon" accept="image/png, image/jpeg" />
            <br />
            <small>(Recommended Size: 192x192 pixels)</small>
          </div> -->
        <!-- Buttons -->
        <div
          class="btn-group d-flex justify-content-start"
          style="margin-top: -31px; margin-bottom: 14px"
        >
          <v-btn
            :loading="processLoading"
            color="success"
            small
            elevation="2"
            class="height-34 width-fit-content mr-2"
            @click="update()"
          >
            Save Notification
          </v-btn>
        </div>
      </div>
      <!-- Preview -->
      <div class="preview col-md-6 text-left">
        <div
          class="w-100 overflow-hidden position-relative"
          style="
            min-height: 88px;
            border: 4px solid #dfe1e5;
            border-radius: 4px;
            padding: 50px 25px 18px 25px;
            box-shadow: rgb(63 63 63 / 56%) 1px 5px 7px 1px;
          "
        >
          <div
            class="w-100 position-absolute d-flex justify-content-between preview-header align-items-center"
            style="
              top: 0;
              right: 0;
              height: 25px !important;
              background: #dad9d9 !important;
            "
          >
            <div class="d-flex justify-content-start">
              <div class="overflow-hidden" style="margin-bottom: 2px">
                <svg
                  width="7"
                  height="7"
                  viewBox="0 0 7 7"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g filter="url(#filter0_i_172_618)">
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M3.724 6.7945C5.41989 6.7945 6.79468 5.41971 6.79468 3.72382C6.79468 2.02793 5.41989 0.653137 3.724 0.653137C2.02811 0.653137 0.65332 2.02793 0.65332 3.72382C0.65332 5.41971 2.02811 6.7945 3.724 6.7945Z"
                      fill="#ED6A5E"
                    />
                  </g>
                  <path
                    d="M6.66674 3.72382C6.66674 5.34905 5.34923 6.66655 3.724 6.66655C2.09877 6.66655 0.781265 5.34905 0.781265 3.72382C0.781265 2.09859 2.09877 0.781082 3.724 0.781082C5.34923 0.781082 6.66674 2.09859 6.66674 3.72382Z"
                    stroke="#CE5347"
                    stroke-width="0.25589"
                  />
                  <defs>
                    <filter
                      id="filter0_i_172_618"
                      x="0.65332"
                      y="0.653137"
                      width="6.1416"
                      height="6.14136"
                      filterUnits="userSpaceOnUse"
                      color-interpolation-filters="sRGB"
                    >
                      <feFlood flood-opacity="0" result="BackgroundImageFix" />
                      <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="BackgroundImageFix"
                        result="shape"
                      />
                      <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                      />
                      <feOffset />
                      <feGaussianBlur stdDeviation="1.53534" />
                      <feComposite
                        in2="hardAlpha"
                        operator="arithmetic"
                        k2="-1"
                        k3="1"
                      />
                      <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0.92549 0 0 0 0 0.427451 0 0 0 0 0.384314 0 0 0 1 0"
                      />
                      <feBlend
                        mode="normal"
                        in2="shape"
                        result="effect1_innerShadow_172_618"
                      />
                    </filter>
                  </defs>
                </svg>
                <svg
                  width="8"
                  height="7"
                  viewBox="0 0 8 7"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g filter="url(#filter0_i_172_619)">
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M3.95935 6.7945C5.65524 6.7945 7.03003 5.41971 7.03003 3.72382C7.03003 2.02793 5.65524 0.653137 3.95935 0.653137C2.26346 0.653137 0.888672 2.02793 0.888672 3.72382C0.888672 5.41971 2.26346 6.7945 3.95935 6.7945Z"
                      fill="#F6BE4F"
                    />
                  </g>
                  <path
                    d="M6.90209 3.72382C6.90209 5.34905 5.58458 6.66655 3.95935 6.66655C2.33412 6.66655 1.01662 5.34905 1.01662 3.72382C1.01662 2.09859 2.33412 0.781082 3.95935 0.781082C5.58458 0.781082 6.90209 2.09859 6.90209 3.72382Z"
                    stroke="#D6A243"
                    stroke-width="0.25589"
                  />
                  <defs>
                    <filter
                      id="filter0_i_172_619"
                      x="0.888672"
                      y="0.653137"
                      width="6.1416"
                      height="6.14136"
                      filterUnits="userSpaceOnUse"
                      color-interpolation-filters="sRGB"
                    >
                      <feFlood flood-opacity="0" result="BackgroundImageFix" />
                      <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="BackgroundImageFix"
                        result="shape"
                      />
                      <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                      />
                      <feOffset />
                      <feGaussianBlur stdDeviation="1.53534" />
                      <feComposite
                        in2="hardAlpha"
                        operator="arithmetic"
                        k2="-1"
                        k3="1"
                      />
                      <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0.960784 0 0 0 0 0.768627 0 0 0 0 0.317647 0 0 0 1 0"
                      />
                      <feBlend
                        mode="normal"
                        in2="shape"
                        result="effect1_innerShadow_172_619"
                      />
                    </filter>
                  </defs>
                </svg>
                <svg
                  width="7"
                  height="7"
                  viewBox="0 0 7 7"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g filter="url(#filter0_i_172_620)">
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M3.19568 6.7945C4.89157 6.7945 6.26636 5.41971 6.26636 3.72382C6.26636 2.02793 4.89157 0.653137 3.19568 0.653137C1.49979 0.653137 0.125 2.02793 0.125 3.72382C0.125 5.41971 1.49979 6.7945 3.19568 6.7945Z"
                      fill="#62C554"
                    />
                  </g>
                  <path
                    d="M6.13842 3.72382C6.13842 5.34905 4.82091 6.66655 3.19568 6.66655C1.57045 6.66655 0.252945 5.34905 0.252945 3.72382C0.252945 2.09859 1.57045 0.781082 3.19568 0.781082C4.82091 0.781082 6.13842 2.09859 6.13842 3.72382Z"
                    stroke="#58A942"
                    stroke-width="0.25589"
                  />
                  <defs>
                    <filter
                      id="filter0_i_172_620"
                      x="0.125"
                      y="0.653137"
                      width="6.1416"
                      height="6.14136"
                      filterUnits="userSpaceOnUse"
                      color-interpolation-filters="sRGB"
                    >
                      <feFlood flood-opacity="0" result="BackgroundImageFix" />
                      <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="BackgroundImageFix"
                        result="shape"
                      />
                      <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                      />
                      <feOffset />
                      <feGaussianBlur stdDeviation="1.53534" />
                      <feComposite
                        in2="hardAlpha"
                        operator="arithmetic"
                        k2="-1"
                        k3="1"
                      />
                      <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0.407843 0 0 0 0 0.8 0 0 0 0 0.345098 0 0 0 1 0"
                      />
                      <feBlend
                        mode="normal"
                        in2="shape"
                        result="effect1_innerShadow_172_620"
                      />
                    </filter>
                  </defs>
                </svg>
              </div>
              <div>
                <span style="height: 15px !important">
                  <svg
                    width="4"
                    height="7"
                    viewBox="0 0 4 7"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M3.56902 6.36268L1.05448 3.84813C1.03814 3.83181 1.02517 3.81244 1.01633 3.7911C1.00748 3.76977 1.00293 3.7469 1.00293 3.72381C1.00293 3.70072 1.00748 3.67785 1.01633 3.65652C1.02517 3.63519 1.03814 3.61581 1.05448 3.59949L3.56902 1.08495"
                      stroke="#575757"
                      stroke-width="0.76767"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </span>
                <span>
                  <svg
                    width="5"
                    height="7"
                    viewBox="0 0 5 7"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M1.30988 6.36268L3.82443 3.84813C3.84077 3.83181 3.85373 3.81244 3.86258 3.7911C3.87142 3.76977 3.87598 3.7469 3.87598 3.72381C3.87598 3.70072 3.87142 3.67785 3.86258 3.65652C3.85373 3.63519 3.84077 3.61581 3.82443 3.59949L1.30988 1.08495"
                      stroke="#ADADAD"
                      stroke-width="0.76767"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </span>
              </div>
              <div>
                <span>
                  <svg
                    width="9"
                    height="7"
                    viewBox="0 0 9 7"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M7.9325 0.653137C8.21515 0.653137 8.44428 0.882269 8.44428 1.16492V6.28272C8.44428 6.56537 8.21515 6.7945 7.9325 6.7945H1.27936C0.99671 6.7945 0.767578 6.56537 0.767578 6.28272V1.16492C0.767578 0.882269 0.99671 0.653137 1.27936 0.653137H7.9325ZM3.83826 1.16492H7.9325V6.28272H3.83826V1.16492ZM3.32648 6.28272H1.27936L1.27936 1.16492H3.32648V6.28272Z"
                      fill="#585758"
                    />
                  </svg>
                </span>
              </div>
            </div>
            <div
              class="position-relative"
              style="
                background: linear-gradient(180deg, #fdfdfd 0%, #f3f3f3 100%);
                padding: 0 35px;
                height: 13px;
                border-radius: 2px;
              "
            >
              <span>
                <svg
                  width="5"
                  height="6"
                  viewBox="0 0 5 6"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M1.16412 2.83835H0.652344V5.90903H4.74658V2.83835H4.2348V2.32657C4.2348 1.47862 3.54741 0.791229 2.69946 0.791229C1.85152 0.791229 1.16412 1.47862 1.16412 2.32657V2.83835ZM1.6759 2.83835H3.72302V2.32657C3.72302 1.76127 3.26476 1.30301 2.69946 1.30301C2.13417 1.30301 1.6759 1.76127 1.6759 2.32657V2.83835Z"
                    fill="#A09FA0"
                  />
                </svg>
              </span>
              <span style="font-size: 5px">{{
                selectedDomain($route.params.id)
              }}</span>
              <span>
                <svg
                  width="7"
                  height="8"
                  viewBox="0 0 7 8"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M3.33722 3.35962L5.64023 1.91917L3.33722 0.478729V1.5468C1.90259 1.67609 0.77832 2.88182 0.77832 4.35013C0.77832 5.90468 2.03853 7.16492 3.59311 7.16492C5.14769 7.16492 6.4079 5.90468 6.4079 4.35013V4.09424H5.89612V4.35013C5.89612 5.62205 4.86506 6.65314 3.59311 6.65314C2.32116 6.65314 1.2901 5.62205 1.2901 4.35013C1.2901 3.1647 2.18572 2.18846 3.33722 2.06117V3.35962Z"
                    fill="#7B7C7C"
                  />
                </svg>
              </span>
            </div>
            <div class="d-flex">
              <div>
                <svg
                  width="7"
                  height="9"
                  viewBox="0 0 7 9"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M4.69328 2.58193C4.78225 2.69172 4.94343 2.70859 5.05313 2.61963C5.16296 2.53064 5.17982 2.36952 5.09086 2.25969L3.87176 0.755336C3.85652 0.7365 3.83903 0.718821 3.81928 0.702921C3.80192 0.688958 3.78267 0.67637 3.76181 0.665687C3.73282 0.650819 3.70133 0.640136 3.66835 0.634388C3.65011 0.631233 3.63149 0.629578 3.61262 0.629578C3.5594 0.629578 3.50842 0.642635 3.46344 0.665687C3.41871 0.688521 3.38197 0.720008 3.35336 0.755336L2.13438 2.25969C2.04542 2.36949 2.06229 2.53064 2.17212 2.61963C2.28182 2.70859 2.443 2.69172 2.53196 2.58193L3.35673 1.56414V5.74738H3.86851V1.56414L4.69328 2.58193Z"
                    fill="#575757"
                  />
                  <path
                    d="M3.86853 3.18848H3.35675V3.70026H3.86853V3.18848Z"
                    fill="#575757"
                  />
                  <path
                    d="M4.38031 3.70026H5.91565V7.7945H1.30963V3.70026H2.84497V3.18848H1.30963C1.027 3.18848 0.797852 3.4176 0.797852 3.70026V7.7945C0.797852 8.07716 1.027 8.30628 1.30963 8.30628H5.91565C6.19828 8.30628 6.42743 8.07716 6.42743 7.7945V3.70026C6.42743 3.4176 6.19828 3.18848 5.91565 3.18848H4.38031V3.70026Z"
                    fill="#575757"
                  />
                </svg>
              </div>
              <div>
                <svg
                  width="7"
                  height="7"
                  viewBox="0 0 7 7"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M6.20282 1.16492H2.62036V1.6767H2.10858V1.16492C2.10858 0.882258 2.33773 0.653137 2.62036 0.653137H6.20282C6.48545 0.653137 6.7146 0.882258 6.7146 1.16492V4.74738C6.7146 5.03004 6.48545 5.25916 6.20282 5.25916H5.69104V4.74738H6.20282V1.16492Z"
                    fill="#575757"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M0.573242 2.70026C0.573242 2.4176 0.802394 2.18848 1.08502 2.18848H4.66748C4.95011 2.18848 5.17926 2.4176 5.17926 2.70026V6.28272C5.17926 6.56538 4.95011 6.7945 4.66748 6.7945H1.08502C0.802394 6.7945 0.573242 6.56538 0.573242 6.28272V2.70026ZM1.08502 2.70026H4.66748V6.28272H1.08502V2.70026Z"
                    fill="#575757"
                  />
                </svg>
              </div>
              <div>
                <svg
                  width="7"
                  height="7"
                  viewBox="0 0 7 7"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M3.85974 0.723816H3.34796V3.28272H0.789062V3.7945H3.34796V6.3534H3.85974V3.7945H6.41864V3.28272H3.85974V0.723816Z"
                    fill="#646565"
                  />
                </svg>
              </div>
            </div>
          </div>
          <div class="d-flex justify-content-start">
            <em></em>
          </div>
          <div class="border overflow-hidden" style="min-height: 82px">
            <div class="d-flex flex-row">
              <!-- Icon Image -->
              <div class="overflow-hidden">
                <img
                  :src="getDrips[selectedDrip(id)].icon"
                  class="icon border prev-icon-img"
                  style="height: 80px; width: 80px !important"
                />
              </div>
              <!-- Title & Message -->
              <div
                style="width: calc(100% - 80px)"
                class="pl-2 pt-1 text-left overflow-y-scroll word-break hide-scrollbar"
              >
                <div class="font-weight-bolder" style="color: #4a5156">
                  {{ getDrips[selectedDrip(id)].title || "Title" }}
                </div>
                <div class="pb-1">
                  {{
                    getDrips[selectedDrip(id)].body || "Type your message ... "
                  }}
                </div>
                <small class="pb-2">{{
                  selectedDomain($route.params.id)
                }}</small>
              </div>
            </div>
            <!-- Large Image -->
            <div class="overflow-hidden">
              <transition
                enter-active-class="animate__animated animate__slideInDown"
                leave-active-class="animate__animated animate__slideOutUp"
              >
                <div
                  class="height-180 lgImage"
                  v-show="shwLargeImg"
                  style="
                    background-size: cover;
                    background-position: top center;
                  "
                >
                  <img
                    class="w-100 prev-lg-img"
                    :src="getDrips[selectedDrip(id)].customization.image"
                  />
                </div>
              </transition>
            </div>
            <!-- Buttons Block -->
            <transition-group
              tag="div"
              v-if="shwActionBtns"
              class="btn-group d-flex flex-column"
              enter-active-class="animate__animated animate__backInLeft animate__faster"
              leave-active-class="animate__animated animate__backOutLeft animate__faster"
            >
              <button
                :key="0"
                v-if="shwBtn1 || shwActionBtns"
                class="border-bottom border-top color-black m-0 pl-3 py-1 text-center"
                style="font-weight: 400 !important"
              >
                {{ button1.button1.title || "Button1" }}
              </button>
              <button
                :key="1"
                v-if="shwBtn2"
                class="color-black m-0 pl-3 py-1 text-center"
                style="font-weight: 400 !important"
              >
                {{ button2.button2.title || "Button2" }}
              </button>
            </transition-group>
          </div>
        </div>
      </div>
    </div>
    <!-- Loading Spinner -->
    <div
      class="d-flex justify-content-center align-items-center spinner-block py-5"
      v-if="loading"
    >
      <BSpinner variant="primary" label="Large Spinner" />
    </div>
    <!-- Error Pop-Up -->
    <Error v-if="error" :error="error" />
    <!-- Success Snackbar -->
    <transition
      class="animate__faster"
      enter-active-class="animate__animated animate__fadeIn animate__faster"
      leave-active-class="animate__animated animate__fadeOut animate__faster"
    >
      <SuccessSnackbar
        v-if="success"
        @update-success="handleUpdateToSuccessSnackbar"
        message="Successfully!"
      />
    </transition>
    <!-- Failure Snackbar -->
    <transition
      class="animate__faster"
      enter-active-class="animate__animated animate__fadeIn animate__faster"
      leave-active-class="animate__animated animate__fadeOut animate__faster"
    >
      <FailureSnackbar
        v-if="failure"
        @update-failure="handleUpdateToFailureSnackbar"
        message="Fill the required fields out!"
      />
    </transition>
  </div>
</template>

<script>
import { BSpinner } from "bootstrap-vue";
import { mapState, mapGetters, mapActions } from "vuex";
import { mapMultiRowFields } from "vuex-map-fields";
import Error from "../../Error.vue";
import Customization from "../../../../apis/Customization.js";
import Emoji from "../../../drip/EmojiPicker.vue";

import SuccessSnackbar from "../../SuccessSnackbar.vue";
import FailureSnackbar from "../../FailureSnackbar.vue";

import common from "../../../../mixins/common";
//import Drip from "../../../../apis/Drip";

export default {
  name: "EditDrip",
  props: {
    id: {
      type: [Number, String],
      required: true,
    },
    domainId: {
      type: [Number, String],
    },
  },
  components: {
    BSpinner,
    Emoji,
    Error,
    SuccessSnackbar,
    FailureSnackbar,
  },
  mixins: [common],
  data() {
    return {
      success: false,
      failure: false,
      input: "",
      search: "",
      baseLgImag: "",
      showSchedule: false,
      source: "",
      medium: "",
      name: "",
      expiryType: "",
      ttl: "",
      button1: {
        button1: {
          title: "",
          url: "",
        },
      },
      button2: {
        button2: {
          title: "",
          url: "",
        },
      },
      json: [],
      shwActionBtns: false,
      shwLargeImg: false,
      shwBtn1: false,
      shwBtn2: false,
      shwIcons: false,
      loading: true,
      processLoading: false,
      rules: {
        required: (value) => !!value || "Required.",
        titleCounter: (value) =>
          (!!value && value.length <= 30) || "Max 30 characters",
        bodyCounter: (value) =>
          (!!value && value.length <= 50) || "Max 50 characters",
      },
    };
  },
  computed: {
    ...mapState({
      drips: (state) => state.welcomeDrip.drips[0],
      error: (state) => state.welcomeDrip.errorWelcomeDrip,
    }),
    ...mapGetters(["selectedDrip", "getDrips"]),
    ...mapGetters(["getDrips", "selectedDomain"]),
    ...mapMultiRowFields(["drips"]),
  },
  mounted() {
    setTimeout(() => {
      this.loading = false;
    }, 1500);

    this.shw = true;
    this.shwLargeImg =
      this.getDrips[this.selectedDrip(this.id)].customization.image;
    this.shwActionBtns =
      !!this.getDrips[this.selectedDrip(this.id)].customization.button1 ||
      !!this.getDrips[this.selectedDrip(this.id)].customization.button2;
    this.shwBtn1 =
      !!this.getDrips[this.selectedDrip(this.id)].customization.button1;
    this.shwBtn2 =
      !!this.getDrips[this.selectedDrip(this.id)].customization.button2;

    this.showSchedule =
      this.checkField(this.getDrips[this.selectedDrip(this.id)]["schedules"])[
        "after_mins"
      ] ||
      this.checkField(this.getDrips[this.selectedDrip(this.id)]["schedules"])[
        "after_hours"
      ] ||
      this.checkField(this.getDrips[this.selectedDrip(this.id)]["schedules"])[
        "after_days"
      ];

    if (this.getDrips[this.selectedDrip(this.id)].customization.button1) {
      this.button1.button1.title =
        this.getDrips[this.selectedDrip(this.id)].customization.button1.title;
    }
    if (this.getDrips[this.selectedDrip(this.id)].customization.button2) {
      this.button2.button2.title =
        this.getDrips[this.selectedDrip(this.id)].customization.button2.title;
      setTimeout(() => {
        document.querySelectorAll("select[name='btns']")[0].value = 2;
      }, 1500);
    }
  },
  methods: {
    ...mapActions(["updateDrip"]),
    // Request To Update
    update() {
      this.processLoading = true;

      setTimeout(() => {
        this.processLoading = false;
      }, 2000);

      let ttlForJson = "";
      let data = new Array();
      let formData = new FormData();
      let formData1 = new FormData();
      let icon = document.getElementById("icon");
      let image = document.getElementById("lgImage");

      if (!this.getDrips[this.selectedDrip(this.id)].title) {
        this.failure = true;

        return false;
      }

      // Check Schedule
      if (this.getDrips[this.selectedDrip(this.id)].schedules !== undefined) {
        this.getDrips[this.selectedDrip(this.id)].schedule =
          this.getDrips[this.selectedDrip(this.id)].schedules[0];
        delete this.getDrips[this.selectedDrip(this.id)].schedules;
      }

      // Assign Domain Id
      this.getDrips[this.selectedDrip(this.id)].domain_id =
        this.$route.params.id || this.domainId;

      if (this.getDrips[this.selectedDrip(this.id)].schedules !== undefined) {
        this.getDrips[this.selectedDrip(this.id)].schedule =
          this.getDrips[this.selectedDrip(this.id)].schedules[0];
        delete this.getDrips[this.selectedDrip(this.id)].schedules;
      }

      // Check Button 1
      if (this.button1.button1.title && this.shwActionBtns) {
        if (this.getDrips[this.selectedDrip(this.id)].customization.button1) {
          delete this.getDrips[this.selectedDrip(this.id)].customization
            .button1;
          Object.assign(
            this.getDrips[this.selectedDrip(this.id)].customization,
            this.button1
          );
        } else {
          Object.assign(
            this.getDrips[this.selectedDrip(this.id)].customization,
            this.button1
          );
        }
      } else {
        if (this.getDrips[this.selectedDrip(this.id)].customization.button1) {
          delete this.getDrips[this.selectedDrip(this.id)].customization
            .button1;
        }
      }

      // Check Button 2
      if (this.button2.button2.title && this.shwActionBtns && this.shwBtn2) {
        if (this.getDrips[this.selectedDrip(this.id)].customization.button2) {
          delete this.getDrips[this.selectedDrip(this.id)].customization
            .button2;
          Object.assign(
            this.getDrips[this.selectedDrip(this.id)].customization,
            this.button2
          );
        } else {
          Object.assign(
            this.getDrips[this.selectedDrip(this.id)].customization,
            this.button2
          );
        }
      } else {
        if (this.getDrips[this.selectedDrip(this.id)].customization.button2) {
          delete this.getDrips[this.selectedDrip(this.id)].customization
            .button2;
        }
      }

      if (!this.getDrips[this.selectedDrip(this.id)].customization.ttl) {
        delete this.getDrips[this.selectedDrip(this.id)].customization.ttl;
      }

      if (icon && icon.files.length) {
        formData.append("image", icon.files[0]);
        formData.append("type", "icon");

        Customization.uploadImg(formData)
          .then((response) => {
            this.getDrips[this.selectedDrip(this.id)].icon =
              response.data.data[0].full_url;
          })
          .then(() => {
            if (this.shwLargeImg && image && image.files.length) {
              formData1.append("image", image.files[0]);
              formData1.append("type", "image");

              Customization.uploadImg(formData1)
                .then((response) => {
                  Object.assign(
                    this.getDrips[this.selectedDrip(this.id)].customization,
                    { image: response.data.data[0].full_url }
                  );
                })
                .then(() => {
                  if (this.getDrips[this.selectedDrip(this.id)].title) {
                    data.push(this.getDrips[this.selectedDrip(this.id)]);
                    this.updateDrip(data).then(() => {
                      this.success = true;
                      //this.$emit("showSnackbar", true);
                    });
                  } else {
                    this.errorInput = true;
                  }
                });
            } else if (!this.shwLargeImg) {
              if (
                this.getDrips[this.selectedDrip(this.id)].customization
                  .image !== undefined
              ) {
                delete this.getDrips[this.selectedDrip(this.id)].customization
                  .image;
              }

              data.push(this.getDrips[this.selectedDrip(this.id)]);
              this.updateDrip(data).then(() => {
                this.success = true;
                //this.$emit("showSnackbar", true);
              });
            } else {
              data.push(this.getDrips[this.selectedDrip(this.id)]);
              this.updateDrip(data).then(() => {
                this.success = true;
                //this.$emit("showSnackbar", true);
              });
            }
          });
      } else {
        if (this.shwLargeImg && image && image.files.length) {
          formData1.append("image", image.files[0]);
          formData1.append("type", "image");

          Customization.uploadImg(formData1)
            .then((response) => {
              Object.assign(
                this.getDrips[this.selectedDrip(this.id)].customization,
                { image: response.data.data[0].full_url }
              );
            })
            .then(() => {
              data.push(this.getDrips[this.selectedDrip(this.id)]);
              this.updateDrip(data).then(() => {
                this.success = true;
                //this.$emit("showSnackbar", true);
              });
            });
        } else if (!this.shwLargeImg) {
          if (
            this.getDrips[this.selectedDrip(this.id)].customization.image !==
            undefined
          ) {
            delete this.getDrips[this.selectedDrip(this.id)].customization
              .image;
          }

          data.push(this.getDrips[this.selectedDrip(this.id)]);
          this.updateDrip(data).then(() => {
            this.success = true;
            //this.$emit("showSnackbar", true);
          });
        } else {
          data.push(this.getDrips[this.selectedDrip(this.id)]);
          this.updateDrip(data).then(() => {
            this.success = true;
            //this.$emit("showSnackbar", true);
          });
        }
      }

      // Request To Add New Drip
      //setTimeout(() => {
      // this.updateDrip(this.getDrips).then(() => {
      //   this.$parent.showEdit = false;
      // });
      //}, 3000);
    },
    checkField(field) {
      if (field === undefined) {
        return this.getDrips[this.selectedDrip(this.id)]["schedule"];
      } else {
        return this.getDrips[this.selectedDrip(this.id)]["schedules"][0]
          ? this.getDrips[this.selectedDrip(this.id)]["schedules"][0]
          : this.getDrips[this.selectedDrip(this.id) + 1]["schedules"][0];
      }
    },
    // Add Preview Large Image
    lgImgForPush() {
      // Large Picture
      var lgImg = document.querySelector(".prev-lg-img");
      var lgImgFile = document.getElementById("lgImage").files[0];

      // Initialize Reared
      var reader = new FileReader();
      // Set Image Links To Selectors Attribute
      reader.onloadend = function () {
        // Large Image
        //for (let el of lgImg) {
        lgImg.src = reader.result;
        //}
      };
      // Read Content As File (Large Image)
      if (lgImgFile) {
        reader.readAsDataURL(lgImgFile);
      } else {
        lgImg.style.backgroundImage = "";
      }
    },
    // Add Preview Icon Image
    iconImgForPush() {
      // Icon
      var iconImg = document.querySelector(".prev-icon-img");
      var iconImgFile = document.querySelector("#icon").files[0];
      // Initialize Reared
      var reader = new FileReader();

      // Set Image Links To Selectors Attribute
      reader.onloadend = function () {
        // Icon Image
        iconImg.src = reader.result;
      };

      // Read Content As File (Icon)
      if (iconImgFile) {
        reader.readAsDataURL(iconImgFile);
      } else {
        iconImg.src = "";
      }

      this.shwIcons = "block";
    },
  },
  watch: {
    id(id) {
      this.loading = true;

      setTimeout(() => {
        this.loading = false;
      }, 1500);

      this.shwLargeImg = this.getDrips[this.selectedDrip(id)].customization
        .image
        ? true
        : false;
      this.shwActionBtns = this.getDrips[this.selectedDrip(id)].customization
        .button1
        ? true
        : false;
      this.shwBtn1 = this.getDrips[this.selectedDrip(id)].customization.button1
        ? true
        : false;
      this.shwBtn2 = this.getDrips[this.selectedDrip(id)].customization.button2
        ? true
        : false;
      this.showSchedule =
        this.checkField(this.getDrips[this.selectedDrip(id)]["schedules"])[
          "after_mins"
        ] ||
        this.checkField(this.getDrips[this.selectedDrip(id)]["schedules"])[
          "after_hours"
        ] ||
        this.checkField(this.getDrips[this.selectedDrip(id)]["schedules"])[
          "after_days"
        ];

      if (this.getDrips[this.selectedDrip(this.id)].customization.button1) {
        this.button1.button1.title =
          this.getDrips[this.selectedDrip(this.id)].customization.button1.title;
      } else {
        this.button1.button1.title = "";
      }

      if (this.getDrips[this.selectedDrip(this.id)].customization.button2) {
        this.button2.button2.title =
          this.getDrips[this.selectedDrip(this.id)].customization.button2.title;
        setTimeout(() => {
          document.querySelectorAll("select[name='btns']")[0].value = 2;
        }, 1500);
      } else {
        this.button2.button2.title = "";
      }
    },
  },
};
</script>

<style>
/* .container {
  overflow: unset !important;
} */
.v-data-table__wrapper {
  overflow-x: unset !important;
  overflow-y: unset !important;
}
input[type="checkbox"] {
  height: 12px;
  width: 12px;
  margin: 6px;
}
button.v-icon {
  color: #c6c6c6 !important;
}
.lgImage {
  width: 100%;
  height: 200px;
  background-size: cover;
  background-position: center;
}
.preview-header {
  border-bottom: 1px solid #bdbebe;
}
.preview-header div:nth-child(1) div + div {
  margin: 0 7px;
}
.preview-header div:nth-child(1) div svg {
  margin: 0 1.5px;
}
.preview-header div div:nth-child(2) {
  display: flex;
  align-items: center;
}
.preview-header div div:nth-child(2) span {
  background: linear-gradient(180deg, #fdfdfd 0%, #f3f3f3 100%);
  display: flex;
  justify-content: center;
  align-items: center;
  height: 15px;
  width: 15px;
  border-radius: 2.5px;
}
.preview-header div div:nth-child(2) span:nth-child(1) {
  margin-right: 1px;
}
.preview-header div div:nth-child(2) span:nth-child(2) {
  padding: 3px 3px 3px 5px;
}
.preview-header div:nth-child(1) div:nth-child(3),
.preview-header div:nth-child(3) div,
.preview-header div:nth-child(3),
.preview-header div:nth-child(2),
.preview-header div:nth-child(2) span:nth-child(1),
.preview-header div:nth-child(2) span:nth-child(3),
.preview-header div:nth-child(1) div:nth-child(3) span {
  display: flex;
  align-items: center;
}
.preview-header div:nth-child(1) div:nth-child(3) {
  margin: 0 !important;
}
.preview-header div:nth-child(1) div:nth-child(3) span,
.preview-header div:nth-child(3) div {
  background: linear-gradient(180deg, #fdfdfd 0%, #f3f3f3 100%);
}
.preview-header div:nth-child(1) div:nth-child(3) span {
  padding: 0 6px;
  border-radius: 2px;
  height: 15px !important;
}
.preview-header div:nth-child(3) div:nth-child(1) {
  padding: 0 6px;
  height: 12px;
  margin: 0 4px;
  border-radius: 2px;
}
.preview-header div:nth-child(3) div:nth-child(2) {
  padding: 0 6px;
  height: 12px;
  margin: 0 4px 0 0;
  border-radius: 2px;
}
.preview-header div:nth-child(3) div:nth-child(3) {
  background: #bdbebe;
  padding: 0 3px;
  height: 14px;
  display: flex;
  align-items: center;
  margin-bottom: -12px;
}
.preview-header div:nth-child(2) span:nth-child(1) {
  height: 8px;
  margin-right: 3px;
}
.preview-header div:nth-child(2) span:nth-child(2) {
  font-size: 5px;
  color: #4c4c4c;
}
.preview-header div:nth-child(2) span:nth-child(3) {
  position: absolute;
  right: 2px;
  height: 10px;
}
</style>
